import { RefObject } from "react";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import IBaseDTO from "src/Interfaces/baseDTO";

export enum NotificationsDisplayTo{
  ALL_USERS = 1,
  ADMINISTRATORS = 2,
  NO_ADMINISTRATORS = 3
}

export enum NotificationsType{
  SUCCESS = 1,
  INFORMATION = 2,
  WARNING = 3,
  ERROR = 4
}

export interface INotifications extends IBaseDTO {
    efn001Id: number;
    efn001Msgsimples: string;
    efn001Msgcompleta: string;
    efn001Tipo: number;
    efn001Dtinicial: Date;
    efn001Dtfinal: Date;
    efn001Mostrar: number;
}

export interface filterNotifications {
    displayTo: string;
    date: string;
    filter: string;
}

export interface IRefNotificationsModals {
    actionButtonAdd: () => void;
    actionButtonChange: (row: INotifications) => void;
    actionButtonDelete: (row: INotifications) => void;
}

export interface IComponentNotificationsModals {
    paginationRef: RefObject<IForwardPagination>
}
